import { IEntity } from "@interfaces/entity";
import { Type } from "class-transformer";

export class Profile implements IEntity {
  id: string;
  name: string;
  isErk: boolean;
  isOcpp16: boolean;
  isOcpp20: boolean;
  isOcpp201: boolean;
  numberOfConnectors: number;
  isUpdatable: boolean;
  isMobile: boolean;
  isAc: boolean;
  isDc: boolean;
  isPnc: boolean;
  isBidi:boolean;

  minBidiChargePower: number;
  maxBidiChargePower: number;
  minBidiDischargePower: number;
  maxBidiDischargePower: number;

  entityName = "Profile";

  constructor(formValue?: Partial<Profile>) {
    Object.assign(this, formValue);
  }

  getPrimaryKey() {
    return this.id;
  }

  updateValues(formValue: Partial<Profile>) {
    Object.assign(this, formValue);
  }
}
